export default __webpack_public_path__ + "static/media/logoEc.67793630.png";